import React from 'react';
import PropTypes from 'prop-types';

import RestoreIcon from '@mui/icons-material/Restore';
import WarningIcon from '@mui/icons-material/Warning';

import IconError from '../IconError';

import app from '../../app.module.css';
import common from './formElementStyles/commonFormElements.module.css';

const TextInputField = ({
    label = '',
    subLabel = '',
    id = '',
    type = 'text',
    disabled = false,
    maxLength = 300000,
    min = 0,
    max = 300000,
    placeholder = '',
    autoComplete = 'off',
    value,
    mandatory = false,
    customClass = '',
    customLabelClass = '',
    error = {},
    warning = '',
    onPaste,
    onChange,
    onEnter,
    onSearchAuditItems,
    isAuditable = false
}) => {
    // EVENT HANDLERS
    const onKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            onEnter();
        }
    };

    // RENDER
    return (
        <div
            className={`${common.fieldWrapper} ${common[customClass]}`}
            data-testid={`textField-${id}`}>
            {subLabel && <div>{subLabel}</div>}
            <label htmlFor={id} className={`${common.formLabel} ${common[customLabelClass]}`}>
                <span>
                    {label} {mandatory && <sup>*</sup>}
                </span>
                {isAuditable && (
                    <div>
                        <RestoreIcon onClick={() => onSearchAuditItems(label)} />
                    </div>
                )}
            </label>
            <input
                id={id}
                aria-required={mandatory}
                type={type}
                role="textbox"
                data-testid={'textField' + id}
                disabled={disabled}
                placeholder={placeholder}
                autoComplete={autoComplete}
                maxLength={maxLength}
                min={min}
                max={max}
                value={value}
                className={common.fieldInput}
                onChange={onChange}
                onPaste={onPaste}
                {...(onEnter && { onKeyDown })}
            />
            {error?.error && (
                <div className={app.fadein}>
                    <IconError text={error} />
                </div>
            )}
            {warning && !error?.error && (
                <div className={`${common.warning} ${app.fadein}`}>
                    <WarningIcon />
                    {warning}
                </div>
            )}
        </div>
    );
};

TextInputField.propTypes = {
    disabled: PropTypes.bool,
    label: PropTypes.string,
    subLabel: PropTypes.string,
    mandatory: PropTypes.bool,
    type: PropTypes.string,
    id: PropTypes.string,
    maxLength: PropTypes.number,
    min: PropTypes.number,
    max: PropTypes.number,
    customClass: PropTypes.string,
    customLabelClass: PropTypes.string,
    placeholder: PropTypes.string,
    autoComplete: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    error: PropTypes.object,
    warning: PropTypes.string,
    onPaste: PropTypes.func,
    onChange: PropTypes.func,
    onEnter: PropTypes.func,
    onSearchAuditItems: PropTypes.func,
    isAuditable: PropTypes.bool
};

export default TextInputField;
